import {
  ActionSheetController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Component, Renderer2 } from '@angular/core';
import {
  CompetitionDetails,
  CompetitionInfo,
  CompetitionTeams,
  FlightInfo,
  Teams,
} from 'src/data/competition-data';
import { GameRoundInfo } from 'src/data/game-round';
import { adjustViewZIndex } from 'src/globals';
import * as moment from 'moment';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { NavigationExtras, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
  CompetitionData,
  CompetitionTeamData,
  CompetitionTeamPlayerData,
  CompetitionTeamWithPlayersView,
} from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
/*
Generated class for the Competition Sponsors page.

See http://ionicframework.com/docs/v2/components/#navigation for more info on
Ionic pages and navigation.
*/
@Component({
  selector: 'app-competition-teams',
  templateUrl: './competition-teams.page.html',
  styleUrls: ['./competition-teams.page.scss'],
})
export class CompetitionTeamsPage {
  appFooterHide: boolean = true;
  public competition: CompetitionInfo;
  public details: CompetitionDetails;
  public gameRound: GameRoundInfo;
  public visible: boolean;
  public flights: Array<FlightInfo> = new Array<FlightInfo>();
  //  private flightMembers: Array<FlightMember> = new Array<FlightMember>();
  public filteredFlight: Array<FlightInfo> = new Array<FlightInfo>();
  public searchQuery: string = '';
  public teamList: Array<string> = new Array<string>();
  // public compTeams: CompetitionTeams; //  //Array<CompetitionTeams> = new Array<CompetitionTeams>();
  public compTeams: Array<CompetitionTeamWithPlayersView> = [];
  public filteredCompTeams: CompetitionTeamWithPlayersView[]; // | Teams[];
  public shownItem: Teams;
  mode: string = 'compTeams';
  compTeamPlayers: Array<CompetitionTeamPlayerData> = [];
  compData: CompetitionData;
  newCompTeams: any; //|| CompetitionTeamData;
  filteredNewCompTeams: Array<any>;

  constructor(
    private nav: NavController,
    private renderer: Renderer2,
    private keyboard: Keyboard,
    private navParams: NavParams,
    private loadingCtl: LoadingController,
    private compService: CompetitionService,
    private actionSheetCtl: ActionSheetController,
    private toastCtl: ToastController,
    private platform: Platform,
    private modalCtl: ModalController,
    private router: Router,
    private location: Location,
    private flightService: ClubFlightService,
    private mg2uUtils: mygolfUtils
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick();
    }

    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compData = this.router.getCurrentNavigation().extras.state.compData;
    this.flights = this.router.getCurrentNavigation().extras.state.flights;
    this.gameRound = this.router.getCurrentNavigation().extras.state.gameRound;
    this.compTeams = this.router.getCurrentNavigation().extras.state.compTeams;
    this.compTeamPlayers = this.router.getCurrentNavigation().extras.state.compTeamPlayers;
    this.newCompTeams = this.router.getCurrentNavigation().extras.state.newCompTeams;

    if (this.router.getCurrentNavigation().extras.state.mode) {
      this.mode = this.router.getCurrentNavigation().extras.state.mode;
      if (this.mode === 'matchTeams') this.filteredNewCompTeams = this.newCompTeams;
    } else this.mode = 'compTeams';
    this.filteredFlight = this.flights;

    this.visible = false;
    this.searchQuery = '';
    if (this.mode === 'compTeams') {
      // this.filteredCompTeams = this.compTeams.competitionTeams;
      this.filteredCompTeams = this.compTeams;
      for (let i = 1; i <= 30; i++) {
        let teamName = 'Team ' + i;
        this.teamList.push(teamName);
      }
    }
  }

  ngOnInit() {
    console.debug('init filtered comp teams: ', this.filteredCompTeams, this.teamList);
    console.debug(
      'init new comp team: ',
      this.filteredNewCompTeams,
      this.newCompTeams,
      this.compTeamPlayers
    );
  }

  // goHome() {
  //   this.router.navigate(['tabs/player-home']);
  // }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  ionViewWillLeave() {
    if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
  }

  public onTeamDetails(team: CompetitionTeamWithPlayersView, event?) {
    let navigationExtras: NavigationExtras = {
      state: {
        team: team,
        compId: this.compData?.id,
        openAsModal: false,
        mode: this.mode,
      },
    };

    this.router.navigate(['tabs/competition-teams-details'], navigationExtras);
  }

  public onMatchTeamDetails(team: CompetitionTeamData, event?) {
    let _compTeamPlayers = this.compTeamPlayers.filter(ctp => {
      return ctp?.teamId === team?.id;
    });
    let navigationExtras: NavigationExtras = {
      state: {
        teamPlayers: _compTeamPlayers,
        compId: this.compData?.id,
        openAsModal: false,
        mode: this.mode,
        matchTeam: team,
      },
    };

    this.router.navigate(['tabs/competition-teams-details'], navigationExtras);
  }

  onRefreshClick(refresher) {
    this._refreshCompetitionTeams(refresher);
  }

  toggle(searchBar) {
    this.visible = searchBar; //!this.visible;
  }

  onSearchCancel() {
    this.toggle(false);
  }

  onSearchInput(searchbar) {
    if (this.mode === 'compTeams') {
      if (this.searchQuery && this.searchQuery.length > 0)
        this.filteredCompTeams = this.compTeams.filter((team: CompetitionTeamWithPlayersView) => {
          return team.teamName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0;
        });
      else this.filteredCompTeams = this.compTeams;
    } else if (this.mode === 'matchTeams') {
      if (this.searchQuery && this.searchQuery.length > 0)
        this.filteredNewCompTeams = this.newCompTeams.filter((team: any) => {
          return team.teamName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0;
        });
      else this.filteredNewCompTeams = this.newCompTeams;
    }
    if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
  }

  public onHomeClick() {
    this.router.navigate(['tabs/player-home']);
  }

  private async _refreshCompetitionTeams(refresher) {
    let loader = await this.loadingCtl.create({
      message: 'Loading teams list, Please wait...',
    });

    loader.present().then(() => {
      this.compService.getCompetitionTeams(this.competition.competitionId).subscribe(
        (compTeams: any) => {
          loader.dismiss().then(() => {
            this.compTeams = compTeams;
            this.filteredCompTeams = this.compTeams;
            this.searchQuery = '';
          });
        },
        error => {
          loader.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error refreshing competition teams'
            );
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          });
        },
        () => {
          if (refresher) refresher.complete();

          if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
        }
      );
    });
  }

  onBackpage() {
    this.location.back();
    // this.router.navigate(['tabs/competition-details']);
  }

  convStartTime(flightTime) {
    return moment(flightTime).format('HH:mm');
  }

  teamsList: Array<any>;
  refreshCompTeamPlayers() {
    this.compTeamPlayers = [];
    this.teamsList = [];
    this.flightService
      .getCompTeamPlayers(this.compData?.id)
      .subscribe((compTeamPlayersList: Array<CompetitionTeamPlayerData>) => {
        if (compTeamPlayersList?.length) {
          this.compTeamPlayers = compTeamPlayersList;
          this.teamsList = this.mg2uUtils.getUnique(compTeamPlayersList, 'competitionTeamId');
        }
      });
  }

  getTeamInfo(team: CompetitionTeamData, attribute) {
    //for matchplay
    let _teamInfo = this.compTeamPlayers?.filter(ctp => {
      return ctp?.teamId === team?.id;
    });
    // console.debug("get team info ", team, attribute, this.compTeamPlayers, _teamInfo)
    switch (attribute) {
      case 'teamName':
        return team?.teamName;
      case 'totalMembers':
        return team?.totalTeamMembers || _teamInfo?.length;
      case 'whoCaptain':
        let _captain = _teamInfo?.find(ctp => {
          return ctp?.captain;
        });
        return _captain?.competitionPlayer?.player?.playerName;
      case 'teamShortName':
        return team?.teamShortName;
    }
  }

  getTeamCaptainName(team: CompetitionTeamWithPlayersView) {
    let _captainInfo = team?.players?.find(ctp => {
      return ctp?.captain;
    });
    if (!_captainInfo || _captainInfo === undefined) return '-';
    return _captainInfo?.player?.playerName;
  }
}
